export default function(x) {
  return (x * x * x * (35 / 3072));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/proj4/lib/common/e3fn.js
// module id = 14
// module chunks = 4